module.exports = __webpack_public_path__ + "9d84f8696d7d91271975f76cae2ec56c.pdf";